// localhost
export const BaseUrl = 'http://127.0.0.1:8000/api'

// remote host
// export const BaseUrl = 'https://shadialmohtaseb.pythonanywhere.com/api/'
